import { z } from 'zod'
import { EVALocale } from '~library/enums'

/** 多語系名稱 Schema */
const localizedNameSchema = z.record(z.enum(EVALocale), z.string())

/** Community 地區物件 Schema */
const communitySchema = z.object({
  /** 多語系名稱 */
  name: localizedNameSchema
})

/** Continent 洲別物件 Schema */
const continentSchema = z.object({
  /** 繁體中文名稱 */
  zhtw: z.string(),
  /** 英文名稱 */
  enus: z.string(),
  /** 地區列表 */
  communities: z.record(z.string(), communitySchema)
})

/** Airport 機場物件 Schema */
const airportSchema = z.object({
  /** 洲別代碼 */
  continent_code: z.string(),
  /** 地區代碼 */
  community_code: z.string(),
  /** 國家代碼 */
  country_code: z.string(),
  /** 多語系名稱 */
  name: localizedNameSchema,
  /** 出發描述 */
  desc_dep: z.string().nullable(),
  /** 抵達描述 */
  desc_arr: z.string().nullable()
})

/** 長榮航空城市字典 Schema */
export const evaCityDictionarySchema = z.object({
  /** 洲別列表 */
  continents: z.record(z.string(), continentSchema),
  /** 機場列表 */
  airports: z.record(z.string(), airportSchema)
})

export interface EvaCityDictionary extends z.infer<
  typeof evaCityDictionarySchema
> {}
